<template>
    <div class="payment-success">
        <div class="img-cover">
            <img src="@/assets/illustrations/payment_success.png">
            <div class="light"></div>
        </div>
        <h1>Привилегия выдана</h1>
        <p class="thanks">
            Теперь вы Анти-грифер.<br>
            Спасибо за поддержку сервера!
        </p>
        <div class="line"></div>
        <payment_info name="artemivanov29320" perk="Анти-грифер" :cost="749" :date="1582161476694"/>
        <div class="line"></div>
        <p class="care">На всякий случай, сделайте скриншот. Если вдруг будут проблемы, это поможет быстрее их решить.</p>
        <router-link :to="{name: 'home'}">
            <secondary_button>Вернуться на главную</secondary_button>
        </router-link>
    </div>
</template>

<script>
    import payment_info from '@/elements/custom/payment_info.vue'
    import secondary_button from '@/elements/secondary_button.vue'

    export default {
        name: "Payment_Success",
        components:{
            payment_info,
            secondary_button,
        }
    }
</script>

<style scoped lang="scss">
    .payment-success{
        width: 560px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        padding: 48px 96px;
        background-color: $bg_light;
        border-radius: 4px;

        .img-cover{
            position: relative;
            margin-bottom: 24px;
            .light{
                position: absolute;
                bottom: 5%;
                left: 25%;
                right: 25%;
                height: 80px;
                box-shadow: 0 24px 48px rgba($blue, 0.18);
            }
        }
        h1{
            margin-bottom: 8px;
        }
        p.thanks{
            text-align: center;
            font-weight: 500;
            font-size: 18px;
            line-height: 21px;
            margin-bottom: 16px;
        }
        p.care{
            margin-bottom: 32px;
        }
        .line{
            margin: 16px 0;
        }
        @include tablet{
            width: 100%;
            max-width: 520px;
            padding: 36px 48px;

            p.issue ,p.care{
                font-size: 16px;
                line-height: 21px;

                &.care{
                    margin-bottom: 24px;
                }
            }
        }
        @include mobile{
            padding: 32px 24px;

            p.care{
                max-width: unset !important;
            }
        }
    }
</style>